<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :query="query"
      :selection="false"
      label-width="100px"
      @tableRowClik="tableRowClik"
    />
  </div>
</template>

<script>
import { getFirstNowLastDay } from '@/utils/tool'
export default {
  data() {
    return {
      url: '/alarm/count/errorCountlist',
      columns: [
        {
          label: '电桩品牌',
          prop: 'brandName',
          click: true
        }, {
          label: '故障次数',
          prop: 'errorCount'
        }, {
          label: '故障率',
          prop: 'errorCountLv'
        }, {
          label: '平均恢复时长',
          prop: 'goodTime'
        }
      ],
      query: [
        {
          label: '品牌名称',
          prop: 'brandName',
          placeholder: '请输入品牌名称'
        },
        {
          label: '统计时间',
          prop: 'statisticsTime',
          placeholder: '',
          type: 'date3',
          haveValue: true,
          data: this.getFirstNowLastDay()
        }
      ]
    }
  },
  methods: {
    tableRowClik(data) {
      console.log(data)
      const datax = {
        'brandName': data.brandName
      }
      this.$router.push({
        path: 'pileFaultList',
        query: datax
      })
    },
    // 获取当前月起止日期
    getFirstNowLastDay() {
      const arr = getFirstNowLastDay()
      arr.splice(1, 1)
      return arr
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/statistics/pileFault.vue